import React, { useState, FC  } from "react";
import { OverviewDataType, AuthorType } from "data/types";


export interface overviewInputProps {
  className?: string;
  defaultOpen?: boolean;
  overview?: OverviewDataType | undefined;
  author?: AuthorType | undefined;
}



const Overview: FC<overviewInputProps> = ({
  className = "flex-1",
  defaultOpen = false,
  overview,
  author,
}) => {
const [isOpen, setIsOpen] = useState(defaultOpen);
// const [overviewData, setOverviewData] = useState(overview); 

function showOverview(){
    setIsOpen(!isOpen);
    
}

  const renderDetail = () => {
    if (!isOpen) return null;
    const mapURL = `https://www.google.com/maps/embed/v1/view?key=AIzaSyAGVJfZMAKYfZ71nzL_v5i3LjTTWnCYwTY&center=${overview?.map.lat},${overview?.map.lng}&zoom=18&maptype=satellite`;

    return (
      <div className="p-4  rounded-2xl ">
       <div className=" rounded-3xl  ">
               {/* <div className=" flex flex-row"> */}
                  <div className="flex-row text-xs text-left">
                      <span >{overview?.description}</span>                       
                  </div>
                  {/* <div className="flex-row  "> */}
                  {/* <h2 className="text-sm font-bold capitalize text-left pt-[15px]">
                    <span >Open House</span>
                  </h2>
                  <h2 className="text-xs font-bold text-left pt-[8px]">
                    <span >{overview?.openDate}</span>
                  </h2>
                  <div className="text-xs font-medium text-left pt-[2px]">
                    <span >{overview?.openHour}</span>
                  </div> */}
                  <div className="text-xs font-medium text-left pt-[15px]">
                    <span >Lsted by:</span>
                  </div>
                  <div className="text-xs font-medium text-left pt-[2px]">
                    <span >{author?.firstName} {author?.lastName}</span>
                  </div>
                  <div className="text-xs font-medium text-left pt-[2px]">
                    <span >{author?.company}</span>
                  </div>
                  {/* <div className="text-xs font-medium text-left pt-[15px]">
                    <span >Source: {overview?.sourceMls}</span>
                  </div>
                  <div className="text-xs font-medium text-left pt-[2px]">
                    <span >MLS#: {overview?.mls}</span>
                  </div> */}
                  <div className="text-xs font-medium text-left pt-[15px]">
                    <span >Listing Updated: {overview?.lastUpdate}</span>
                  </div>
                  <div className="  rounded-xl z-0 mt-[15px]">
                      <div className="rounded-xl overflow-hidden z-0">
                          <iframe
                          title="x"
                          width="100%"
                          height="200px"
                          loading="lazy"
                          allowFullScreen
                          referrerPolicy="no-referrer-when-downgrade"
                          // src="https://www.google.com/maps/embed/v1/view?key=AIzaSyAGVJfZMAKYfZ71nzL_v5i3LjTTWnCYwTY&center=-33.8569,151.2152&zoom=18&maptype=satellite"
                          src={mapURL}
                         ></iframe>
                      </div>
                  </div>
                  {/* <h2 className="text-sm font-bold text-left pt-[20px]">
                    <span >Take a tour with a buyer’s agent</span>
                  </h2>
                   <div className="inline-flex w-full rounded-lg  pt-[15px]" role="group">
                          <button type="button" className="px-8 py-3 text-xs font-medium text-white bg-[#1A4676] border border-[#1A4676] rounded-l-xl ">
                              in-person
                          </button>
                          <button type="button" className="px-8 py-3 text-xs font-medium text-[#1A4676] bg-white border border-[#1A4676] rounded-r-xl ">
                              Video chat
                          </button>
                  </div>
                  <div className="text-xs font-bold text-left pt-[30px]">
                    <span >Select a preferred time</span>
                  </div>
                 
                  
                  <div className="flex flex-row w-full pt-[15px]"  >
                        <div className=" w-5/6" >
                           <SectionSliderdates itemPerRow={6} uniqueClassName="PageHome2_s1" />     
                        </div>
                        <div className={`flex  w-1/6 justify-end text-white `}>
                            arrow
                        </div>
                  </div>
                  
                  <div className="mt-3  w-full bg-white rounded-lg ">
                        <div className="flex">
                            <select name="hours" className="w-[62px]  backdrop-opacity-0 text-xs  border-0">
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            </select>
                            <span className="text-lg mx-3">:</span>
                            <select name="minutes" className="w-[70px] text-xs mr-4 rounded-none border-0">
                            <option value="0">00</option>
                            <option value="30">30</option>
                            </select>
                            <select name="ampm" className="text-xs border-0">
                            <option value="am">AM</option>
                            <option value="pm">PM</option>
                            </select>
                        </div>
                    </div>

                    <div className="pt-[15px]">
                        
                          <button type="button" className="flex items-center justify-left px-5 py-2 text-xs font-medium text-white bg-[#00D3DB]  rounded-lg ">
                              Request this time
                          </button>
                  </div> */}

               </div>
      </div>
    );
  };

  return (
    <div
      className={`justify-center  relative overflow-hidden  transition-shadow  ${className}`}>
      <div className="flex flex-row w-full " onClick={showOverview} >
            <div className="my-[9px] text-left w-5/6" >
                    <span className="pl-[15px] block text-md font-semibold  flex items-center justify-left h-full">
                    Overview
                    </span>
            </div>
            <div className={`flex  w-1/6 justify-end text-white ${isOpen ? "" : ""}`}>
                <span className="flex rounded-tr-lg items-center justify-center w-[30px] bg-[#00D3DB] cursor-pointer rounded-bl-md">
                    {isOpen ? (
                    <i className=" text-xl font-bold las la-minus"></i> 
                    ) : (
                    <i className="text-xl font-bold las la-plus"></i> 
                    )}
                </span>
            </div>
            
      </div>
      {/* DETAIL */}
      {renderDetail()}
    </div>
  );
};

export default Overview;
